export interface IKey{
    key: string,
    value: string,
    misc: string
}

export class Keys{
    static certType: IKey[] = [
        {key: 'P', value :'PPM', misc: ''},
        {key: 'W', value :'Waived', misc: ''},
        {key: 'C', value :'Compliance', misc: ''},
        {key: 'A', value :'Accredited', misc: ''},
        {key: 'T', value :'HST', misc: ''},
        {key: 'R', value :'Permit', misc: ''},
    ];

    static certType2: IKey[] = [
        {key: 'A', value :'Accredited - A', misc: ''},
        {key: 'C', value :'Compliance - C', misc: ''},
        {key: 'T', value :'HST - T', misc: ''},
        {key: 'P', value :'PPM - P', misc: ''},
        {key: 'R', value :'Permit - R', misc: ''},
        {key: 'W', value :'Waived - W', misc: ''},
    ];

    static labType: IKey[] = [
        {key: '01', value :'Emergency Response Service/Ambulance', misc: 'ERS'},
        {key: '02', value :'Ambulatory Surgical Center', misc: 'ASC'},
        {key: '03', value :'Ancillary Testing in Health Care Facility', misc: 'AT'},
        {key: '04', value :'Assisted Living Center', misc: 'ALC'},
        {key: '05', value :'Blood Bank', misc: 'BB'},
        {key: '06', value :'Community Clinic', misc: 'CC'},
        {key: '07', value :'Comp. Outpatiend Rehap. Facility', misc: 'COR'},
        {key: '08', value :'ESRD Dialysis Facility', misc: 'DF'},
        {key: '09', value :'Federally Qualified Health Ctr', misc: 'FQH'},
        {key: '10', value :'Health Fair/Health Screen Testing', misc: 'HFS'},
        {key: '11', value :'Health Maintenance Organization', misc: 'HMO'},
        {key: '12', value :'Home Health Agency', misc: 'HHA'},
        {key: '13', value :'Hospice', misc: 'HSP'},
        {key: '14', value :'Hospital', misc: 'HS'},
        {key: '15', value :'Independent', misc: 'XXX'},
        {key: '16', value :'Industrial', misc: 'IND'},
        {key: '17', value :'Insurance', misc: 'INS'},
        {key: '18', value :'Intermediate Care Facility for Individuals with Intellectual Disabilities', misc: 'ICF'},
        {key: '19', value :'Mobile Laboratory', misc: 'ML'},
        {key: '20', value :'Pharmacy', misc: 'PH'},
        {key: '21', value :'Physician Office', misc: 'PHO'},
        {key: '22', value :'Practitioner Other', misc: 'PRO'},
        {key: '23', value :'Prison', misc: 'Pr'},
        {key: '24', value :'Public Health Laboratories', misc: 'PHL'},
        {key: '25', value :'Rural Health Clinic', misc: 'RHC'},
        {key: '26', value :'School/Student Health Service', misc: 'SHS'},
        {key: '27', value :'Skilled Nursing Facility/Nursing Facility', misc: 'SKN'},
        {key: '28', value :'Tissue Bank/Repositories', misc: 'TBR'},
        {key: '29', value :'Other', misc: 'OT'},
        {key: '30', value :'SOA Registry', misc: 'SR'},
        {key: '36', value :'County Laboratory', misc: 'CL'},
        {key: '100', value :'Out of State', misc: 'OOS'},
        {key: '101', value :'Covid Laboratory', misc: 'CVL'},
    ];

    static complexityType: IKey[] = [
        {key: 'H', value :'High', misc: ''},
        {key: 'D', value :'High Derm', misc: ''},
        {key: 'P', value :'High Path', misc: ''},
        {key: 'M', value :'Moderate', misc: ''},
    ];

    static surveyType: IKey[] = [
        {key: 'Init', value :'Initial', misc: ''},
        {key: 'Accred', value :'Accreditation', misc: ''},
        {key: 'COW', value :'COW', misc: ''},
        {key: 'Recert', value :'Recertification', misc: ''},
        {key: 'Validation', value :'Validation', misc: ''},
        {key: 'Complaint', value :'Complaint', misc: ''},
        {key: 'CMS', value :'CMS', misc: ''},
        {key: 'Other', value :'Other', misc: ''},
        {key: 'PT', value :'Desk  Review', misc: ''}
    ];

    static accreditationKeys: IKey[] = [
        {key: 'A', value :'American Osteopathic Association', misc: 'AOA'},
        {key: 'B', value :'American Association of blood banks', misc: 'AABB'},
        {key: 'C', value :'College of American Pathologists', misc: 'CAP'},
        {key: 'F', value :'Food and Drug Administration', misc: 'FDA'},
        {key: 'H', value :'Accreditation Association for Ambulatory Health Care', misc: 'AAAHC'},
        {key: 'J', value :'Joint Commision on Accreditation of Health Care Organization', misc: 'JC'},
        {key: 'O', value :'American Society for Histocapatibility and Immunogenetics', misc: 'ASHI'},
        {key: 'P', value :'Pacific Northwest Regional Genetics Group', misc: 'NORD'},
        {key: 'Q', value :'Commission on Office Laboratory Accreditation', misc: 'COLA'},
        {key: 'S', value :'Substance Abuse and Mental Health Services Admisitration', misc: 'SAMHSA'},
        {key: '9', value :'Other', misc: ''},
        {key: 'L', value :'American Association of Laboratory Accreditation', misc: 'A2LA'}
    ];

    static scheduleKey: IKey[] = [
        {key: 'W', value :'Waived', misc: ''},
        {key: 'P', value :'Physician Performed Microscopy', misc: ''},
        {key: 'R', value :'SOA Registry', misc: ''},
        {key: 'T', value :'HST', misc: ''},
        {key: 'V', value :'1 - 2,000 Annual Tests', misc: ''},
        {key: 'A', value :'2,001 - 10,000 <= 3 Specialties', misc: ''},
        {key: 'B', value :'2,001 - 10,000 >= 4 Specialties', misc: ''},
        {key: 'C', value :'10,001 - 25,000 <= 3 Specialties', misc: ''},
        {key: 'D', value :'10,001 - 25,000 >= 4 Specialties', misc: ''},
        {key: 'E', value :'25,001 - 50,000  Annual Tests', misc: ''},
        {key: 'F', value :'50,001 - 75,000  Annual Tests', misc: ''},
        {key: 'G', value :'75,001 - 100,000 Annual Tests', misc: ''},
        {key: 'H', value :'100,001 - 500,000 Annual Tests', misc: ''},
        {key: 'I', value :'500,001 - 1,000,000 Annual Tests', misc: ''},
        {key: 'J', value :'1,000,001 - 1,500,000 Annual Tests', misc: ''},
        {key: 'K', value :'1,500,001 - 2,000,000 Annual Tests', misc: ''},
        {key: 'L', value :'2,000,001 - 2,500,000 Annual Tests', misc: ''},
        {key: 'M', value :'2,500,001 - 3,000,000 Annual Tests', misc: ''},
        {key: 'N', value :'3,000,001 - 3,500,000 Annual Tests', misc: ''},
        {key: 'O', value :'3,500,001 - 4,000,000 Annual Tests', misc: ''},
        {key: 'Q', value :'4,000,001 - 5,000,000 Annual Tests', misc: ''},
        {key: 'S', value :'5,000,001 - 6,000,000 Annual Tests', misc: ''},
        {key: 'U', value :'6,000,001 - 7,000,000 Annual Tests', misc: ''},
        {key: 'X', value :'7,000,001 - 8,000,000 Annual Tests', misc: ''},
        {key: 'Y', value :'8,000,001 - 9,000,000 Annual Tests', misc: ''},
        {key: 'Z', value :'9,000,001 - 9,999,999 Annual Tests', misc: ''},
    ];

    static accreditationCode: IKey[] = [
        {key: 'C', value :'C - CAP', misc: ''},
        {key: 'Q', value :'Q - COLA', misc: ''},
        {key: 'J', value :'J - JCAHO', misc: ''},
        {key: '9', value :'9 - Other', misc: ''},
        {key: 'A', value :'A - AOA', misc: ''},
        {key: 'B', value :'B - AABB', misc: ''},
        {key: 'F', value :'F - FDA', misc: ''},
        {key: 'O', value :'O - ASHI', misc: ''},
    ];

    static ownershipTypes: IKey[] = [
        {key: '00', value :'00 - Unknown', misc: ''},
        {key: '01', value :'01 - Religious Affiliation', misc: ''},
        {key: '02', value :'02 - Private', misc: ''},
        {key: '03', value :'03 - Other', misc: ''},
        {key: '04', value :'04 - Proprietary', misc: ''},
        {key: '05', value :'05 - City', misc: ''},
        {key: '06', value :'06 - Government', misc: ''},
        {key: '07', value :'07 - State', misc: ''},
        {key: '08', value :'08 - Federal', misc: ''},
        {key: '09', value :'09 - Other Government', misc: ''},
    ];

    static officeHours: IKey[] = [
        {key: '8-5/M-F', value :'8-5/M-F', misc: ''},
        {key: 'Urgent Care Hours', value :'Urgent Care Hours', misc: ''},
        {key: '24/7', value :'24/7', misc: ''},
        {key: 'Other', value :'Other', misc: ''},
    ];

    static countyCode: IKey[] = [
        {key: '000', value: '000 - Baker', misc: ''},
        {key: '010', value: '010 - Benton', misc: ''},
        {key: '020', value: '020 - Clackamas', misc: ''},
        {key: '030', value: '030 - Clatsop', misc: ''},
        {key: '040', value: '040 - Columbia', misc: ''},
        {key: '050', value: '050 - Coos', misc: ''},
        {key: '060', value: '060 - Crook', misc: ''},
        {key: '070', value: '070 - Curry', misc: ''},
        {key: '080', value: '080 - Deshutes', misc: ''},
        {key: '090', value: '090 - Douglas', misc: ''},
        {key: '100', value: '100 - Gilliam', misc: ''},
        {key: '110', value: '110 - Grant', misc: ''},
        {key: '120', value: '120 - Harney', misc: ''},
        {key: '130', value: '130 - Hood River', misc: ''},
        {key: '140', value: '140 - Jackson', misc: ''},
        {key: '150', value: '150 - Jefferson', misc: ''},
        {key: '160', value: '160 - Josephine', misc: ''},
        {key: '170', value: '170 - Klamath', misc: ''},
        {key: '180', value: '180 - Lake', misc: ''},
        {key: '190', value: '190 - Lane', misc: ''},
        {key: '200', value: '200 - Lincoln', misc: ''},
        {key: '210', value: '210 - Linn', misc: ''},
        {key: '220', value: '220 - Malheur', misc: ''},
        {key: '230', value: '230 - Marion', misc: ''},
        {key: '240', value: '240 - Morrow', misc: ''},
        {key: '250', value: '250 - Multnomah', misc: ''},
        {key: '260', value: '260 - Polk', misc: ''},
        {key: '270', value: '270 - Sherman', misc: ''},
        {key: '280', value: '280 - Tillamook', misc: ''},
        {key: '290', value: '290 - Umatilla', misc: ''},
        {key: '300', value: '300 - Union', misc: ''},
        {key: '310', value: '310 - Wallowa', misc: ''},
        {key: '320', value: '320 - Wasco', misc: ''},
        {key: '330', value: '330 - Washington', misc: ''},
        {key: '340', value: '340 - Wheeler', misc: ''},
        {key: '350', value: '350 - Yamhill', misc: ''}    
    ]

}

export class Misc{
    static type: IKey[] = [
        {key: '', value :'', misc: ''},
    ];

    static months: IKey[] = [
        {key: '1', value :'January', misc: '1'},
        {key: '2', value :'February', misc: '2'},
        {key: '3', value :'March', misc: '3'},
        {key: '4', value :'April', misc: '4'},
        {key: '5', value :'May', misc: '5'},
        {key: '6', value :'June', misc: '6'},
        {key: '7', value :'July', misc: '7'},
        {key: '8', value :'August', misc: '8'},
        {key: '9', value :'September', misc: '9'},
        {key: '10', value :'October', misc: '10'},
        {key: '11', value :'November', misc: '11'},
        {key: '12', value :'December', misc: '12'},
    ];

    static years: IKey[] = [
        {key: '2012', value :'2012', misc: ''},
        {key: '2013', value :'2013', misc: ''},
        {key: '2014', value :'2014', misc: ''},
        {key: '2015', value :'2015', misc: ''},
        {key: '2016', value :'2016', misc: ''},
        {key: '2017', value :'2017', misc: ''},
        {key: '2018', value :'2018', misc: ''},
        {key: '2019', value :'2019', misc: ''},
        {key: '2020', value :'2020', misc: ''},
        {key: '2021', value :'2021', misc: ''},
        {key: '2022', value :'2022', misc: ''},
        {key: '2023', value :'2023', misc: ''},
        {key: '2024', value :'2024', misc: ''},
        {key: '2025', value :'2025', misc: ''},
        {key: '2026', value :'2026', misc: ''},
        {key: '2027', value :'2027', misc: ''},
        {key: '2028', value :'2028', misc: ''},
        {key: '2029', value :'2029', misc: ''},
        {key: '2030', value :'2030', misc: ''},
    ];

}